// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__hBRLF","requiredAsterisk":"Info_requiredAsterisk__ufCI_"};